// eslint-disable-next-line import/no-anonymous-default-export
export default {
    userName: 'Default User',
    userId: null,
    admin: false
}
